import * as React from "react";

export class Root extends React.Component<{}, {}> {
    render() {
        return (
            <table className="rj-racing-table">
                {this.props.children}
            </table>
        );
    }
}